import theme from '../base'

const stepper = {
  MuiStep: {
    styleOverrides: {
      root: {
        maxWidth: theme.spacing(20),
        '&:last-of-type': {
          '& .MuiStepConnector-root': {
            display: 'none',
          },
        },
      },
      horizontal: {
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
  },
  MuiStepConnector: {
    styleOverrides: {
      root: {
        left: `calc(50% + ${theme.spacing(2.5)})`,
        right: `calc(-50% + ${theme.spacing(2.5)})`,
      },
    },
  },
  MuiStepLabel: {
    styleOverrides: {
      label: {
        '&.MuiStepLabel-alternativeLabel': {
          marginTop: 0,
        },
      },
    },
  },
}

export default stepper
